import React from 'react';
import { observer } from 'mobx-react';
import TreeItemImplementation from './implementation/TreeItemImplementation';
import StackLayout from '../../layouts/stackLayout/StackLayoutComponent';
import useActiveThemeVariation from '../../../themes/hooks/UseActiveThemeVariation';
var TreeComponent = function (props) {
    var items = props.items, openedItems = props.openedItems, children = props.children, onTreeItemClicked = props.onTreeItemClicked;
    var activeThemeVariant = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.tree; });
    return (React.createElement(StackLayout, { stretch: true }, items
        .filter(function (x) { return x.parentId === undefined; }).sort(function (a, b) { return a.name.localeCompare(b.name); })
        .map(function (x) { return (React.createElement(TreeItemImplementation, { openedItems: openedItems, onTreeItemClicked: onTreeItemClicked, key: x.id, renderer: children, item: x, indentation: activeThemeVariant.indentation })); })));
};
export default observer(TreeComponent);
//# sourceMappingURL=TreeComponent.js.map